import { SxProps, Theme } from '@mui/material';

export const HEADER_ACCENT_STYLES: Record<string, SxProps<Theme>> = {
  none: {},
  animated: {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '20%',
      height: '100%',
      background:
        'linear-gradient(90deg, transparent, rgba(255, 255, 255, 1), transparent)',
      animation: 'sheen 10s infinite',
    },
    '@keyframes sheen': {
      '0%': {
        left: '-100%',
      },
      '40%': {
        left: '100%',
      },
      '100%': {
        left: '100%',
      },
    },
  } as SxProps<Theme>,
  rainbow: {
    background: `linear-gradient(to right,
            rgb(237, 34, 36),
            rgb(243, 91, 34),
            rgb(249, 150, 33),
            rgb(245, 193, 30),
            rgb(241, 235, 27) 27%,
            rgb(241, 235, 27),
            rgb(241, 235, 27) 33%,
            rgb(99, 199, 32),
            rgb(12, 155, 73),
            rgb(33, 135, 141),
            rgb(57, 84, 165),
            rgb(97, 55, 155),
            rgb(147, 40, 142))`,
  } as SxProps<Theme>,
  timberwolves: {
    background: `linear-gradient(to right,
      #0C2340,
      #236192,
      #9EA2A2,
      #78BE20)`,
  } as SxProps<Theme>,
  vikings: {
    background: `linear-gradient(to right,
    #4F2683,
    #FFC62F,
    #FFFFFF)`,
  } as SxProps<Theme>,
} as const;
